import "core-js/modules/es6.array.sort";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchItemLists, addObjItem, delObjItem, delObjItems, putObjItem } from "@/api/admin/dict";
export default {
  name: "",
  props: {
    itemData: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    var validateSort = function validateSort(rule, value, callback) {
      if (typeof value != "number") {
        return callback(new Error("请输入数字"));
      }

      callback();
    };

    return {
      deleteState: true,
      multipleSelection: [],
      delList: [],
      EditForm: null,
      ruleValidate: {
        sort: [{
          required: false,
          message: "该项必须填写",
          trigger: "blur"
        }, {
          pattern: /^[0-9]\d{0,5}$/,
          message: "只能输入整数： 1～99999"
        }],
        label: [{
          required: true,
          message: "该项必须填写",
          trigger: "blur"
        }, {
          min: 1,
          max: 50,
          message: "长度在 1 到 50 个字符",
          trigger: "blur"
        }],
        value: [{
          required: true,
          message: "该项必须填写",
          trigger: "blur"
        }, {
          min: 1,
          max: 50,
          message: "长度在 1 到 50 个字符",
          trigger: "blur"
        }],
        type: [{
          required: true,
          message: "该项必须填写",
          trigger: "blur"
        }, {
          min: 1,
          max: 50,
          message: "长度在 1 到 50 个字符",
          trigger: "blur"
        }],
        description: [{
          required: true,
          message: "该项必须填写",
          trigger: "blur"
        }, {
          min: 1,
          max: 50,
          message: "长度在 1 到 50 个字符",
          trigger: "blur"
        }],
        remarks: [{
          required: false,
          message: "",
          trigger: "blur"
        }, {
          min: 1,
          max: 200,
          message: "长度在 1 到 200 个字符",
          trigger: "blur"
        }]
      },
      // 表单验证
      formValidate: {
        id: null,
        dictId: "",
        value: "",
        type: "",
        label: "",
        description: "",
        remarks: "",
        sort: 0,
        sysFlag: 0
      },
      // 表单数据绑定
      EditRuleValidate: {
        sort: [{
          required: false,
          message: "该项必须填写",
          trigger: "blur"
        }, {
          pattern: /^[0-9]\d{0,5}$/,
          message: "只能输入整数： 1～99999"
        }],
        label: [{
          required: true,
          message: "该项必须填写",
          trigger: "blur"
        }, {
          min: 1,
          max: 50,
          message: "长度在 1 到 50 个字符",
          trigger: "blur"
        }],
        value: [{
          required: true,
          message: "该项必须填写",
          trigger: "blur"
        }, {
          min: 1,
          max: 50,
          message: "长度在 1 到 50 个字符",
          trigger: "blur"
        }],
        type: [{
          required: true,
          message: "该项必须填写",
          trigger: "blur"
        }, {
          min: 1,
          max: 50,
          message: "长度在 1 到 50 个字符",
          trigger: "blur"
        }],
        description: [{
          required: true,
          message: "该项必须填写",
          trigger: "blur"
        }, {
          min: 1,
          max: 50,
          message: "长度在 1 到 50 个字符",
          trigger: "blur"
        }],
        remarks: [{
          required: false,
          message: "",
          trigger: "blur"
        }, {
          min: 1,
          max: 200,
          message: "长度在 1 到 200 个字符",
          trigger: "blur"
        }]
      },
      // 表单验证
      remarks: null,
      EditFormValidate: {
        id: null,
        dictId: "",
        value: "",
        type: "",
        label: "",
        description: "",
        remarks: "",
        sort: 0,
        sysFlag: 0
      },
      // 表单数据绑定
      dialogVisibleAdd: false,
      dialogVisibleEdit: false,
      page: {
        total: 0,
        // 总页数
        currentPage: 1,
        // 当前页数
        pageSize: 50 // 每页显示多少条

      },
      tableData: [],
      tableLoading: false,
      subDisabled: false
    };
  },
  components: {},
  methods: {
    delAllSelection: function delAllSelection() {
      var _this = this;

      this.$confirm("点击“确定”按钮删除选中内容，否则请点击“取消”按钮！", "信息消息", {
        confirmButtonText: "确定",
        cancelButtonText: "关闭",
        type: "warning"
      }).then(function () {
        _this.delList = _this.delList.concat(_this.multipleSelection);

        var idArr = _this.multipleSelection.map(function (item) {
          return item.id;
        });

        delObjItems(idArr).then(function (res) {
          if (res.data.code == 0) {
            if (_this.tableData.length === idArr.length && _this.page.currentPage > 1) {
              _this.page.total -= 1;
              _this.page.currentPage -= 1;
            }

            _this.$message.success("\u5220\u9664\u6210\u529F");

            _this.multipleSelection = [];

            _this.getItemList();
          }
        });
      });
    },
    // 设置表格行不可选
    checkSelectable: function checkSelectable(row, index) {
      if (row.system == 1) {
        return false;
      }

      return true;
    },
    // 多选操作
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;

      if (this.multipleSelection.length > 0) {
        this.deleteState = false;
      } else {
        this.deleteState = true;
      }
    },

    /**
     * @description: 删除
     * @param:{}
     * @return:
     */
    handleDel: function handleDel(row) {
      var _this2 = this;

      this.$confirm('"是否确认删除标签名为"' + row.label + '"的数据项?', "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        delObjItem(row.id).then(function (res) {
          if (res.data.code == 0) {
            _this2.getItemList();
          } else {
            _this2.$alert(res.data.msg, "提示", {
              confirmButtonText: "确定",
              type: "warning"
            });
          }
        });
      }).catch(function () {});
    },
    //新增的提交及清空
    submitForm: function submitForm(formName) {
      var _this3 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this3.subDisabled = true;
          addObjItem(_this3.formValidate).then(function (res) {
            if (res.data.code == 0) {
              _this3.$refs[formName].resetFields();

              _this3.subDisabled = false;

              _this3.handleCloseAdd();

              _this3.getItemList();
            } else {
              _this3.subDisabled = false;

              _this3.$alert(res.data.msg, "提示", {
                confirmButtonText: "确定",
                type: "warning"
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    //清空新增
    resetForm: function resetForm(formName) {
      var _this4 = this;

      this.$refs[formName].resetFields();
      setTimeout(function () {
        _this4.formValidate.dictId = _this4.itemData.data.id;
        _this4.formValidate.type = _this4.itemData.data.type;
        _this4.formValidate.remarks = "";
      }, 200);
    },
    //编辑的新增及清空
    submitFormEdit: function submitFormEdit(formName) {
      var _this5 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this5.subDisabled = true;
          putObjItem(_this5.EditFormValidate).then(function (res) {
            if (res.data.code == 0) {
              _this5.subDisabled = false;

              _this5.handleCloseEdit();
            } else {
              _this5.subDisabled = false;

              _this5.$alert(res.data.msg, "提示", {
                confirmButtonText: "确定",
                type: "warning"
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    //清空新增
    resetFormEdit: function resetFormEdit(formName) {
      this.EditFormValidate.remarks = this.EditForm.remarks;
      this.EditFormValidate.id = this.EditForm.id;
      this.EditFormValidate.dictId = this.EditForm.dictId;
      this.EditFormValidate.value = this.EditForm.value;
      this.EditFormValidate.type = this.EditForm.type;
      this.EditFormValidate.label = this.EditForm.label;
      this.EditFormValidate.description = this.EditForm.description;
      this.EditFormValidate.description = this.EditForm.description;
      this.EditFormValidate.sort = this.EditForm.sort;
      this.EditFormValidate.sysFlag = this.EditForm.sysFlag;
    },
    handleCloseAdd: function handleCloseAdd() {
      var _this6 = this;

      this.$refs["ruleForm"].resetFields();
      setTimeout(function () {
        _this6.formValidate.remarks = "";
      }, 200);
      this.dialogVisibleAdd = false;
    },
    handleCloseEdit: function handleCloseEdit() {
      this.dialogVisibleEdit = false;
      this.EditForm = null;
      this.getItemList();
    },
    closeModal: function closeModal() {
      this.$emit("closeItem", {
        state: false
      });
      this.itemData.state = false;
    },

    /**
     * @title 打开新增窗口
     * @detail 调用crud的handleadd方法即可
     *
     **/
    handleAdd: function handleAdd() {
      this.dialogVisibleAdd = true;
    },
    handleEdit: function handleEdit(row) {
      this.EditForm = row;
      this.dialogVisibleEdit = true;
      this.remarks = this.EditForm.remarks;
      this.EditFormValidate.remarks = this.EditForm.remarks;
      this.EditFormValidate.id = this.EditForm.id;
      this.EditFormValidate.dictId = this.EditForm.dictId;
      this.EditFormValidate.value = this.EditForm.value;
      this.EditFormValidate.type = this.EditForm.type;
      this.EditFormValidate.label = this.EditForm.label;
      this.EditFormValidate.description = this.EditForm.description;
      this.EditFormValidate.description = this.EditForm.description;
      this.EditFormValidate.sort = this.EditForm.sort;
      this.EditFormValidate.sysFlag = this.EditForm.sysFlag;
    },
    getItemList: function getItemList() {
      var _this7 = this;

      this.tableLoading = true;
      this.formValidate.dictId = this.itemData.data.id;
      this.formValidate.type = this.itemData.data.type;
      fetchItemLists(Object.assign({
        current: this.page.currentPage,
        size: this.page.pageSize,
        dictId: this.itemData.data.id
      })).then(function (response) {
        _this7.tableData = response.data.data.records.sort(function (a, b) {
          return a.sort - b.sort;
        });
        _this7.tableLoading = false;
      });
    }
  }
};